import { Description } from "./styles";

import SectionContainer from "../../ui/SectionContainer";
import HighlightBand from "../../ui/HighlightBand";

import BackgroundImage from "../../../assets/images/sections/world-challenge/background.jpg";
import Illustration from "../../../assets/images/sections/world-challenge/illustration.png";

const WorldChallenge = () => {
  return (
    <SectionContainer backgroundImage={BackgroundImage} padding="100px 20px">
      <Description>
        <HighlightBand>
          <h1>
            FRM WORLD <br />
            CHALLENGE 2025
          </h1>
        </HighlightBand>

        <p>
          Em 2025, a ESP participou, pela primeira vez, do FRM WORLD CHALLENGE,
          torneio que reúne escolas do mundo todo que possuem a metodologia da
          Fundación Real Madrid!
        </p>
        <p>
          Todas as nossas categorias, 10, 12 e 14, chegaram às finais e o sub 10
          consagrou campeão geral 2025!
        </p>

        <a href="https://www.instagram.com/reel/DI1lTDEOHeG/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D">
          CLIQUE AQUI E VEJA COMO FOI!
        </a>
      </Description>

      <img src={Illustration} alt="imagem" />
    </SectionContainer>
  );
};

export default WorldChallenge;
